import WebsiteModal from "./WebsiteModal";
import {svg_include} from "index";
import CookieHelper from "base/CookieHelper";

export default class ZayerModal extends WebsiteModal {
    buildElement() {
        this.$modal = (eotwJSXFactory('div', {className: "modal modal--zayer"}, [
            eotwJSXFactory('div', {className: "modal__overlay js-close"}),
            eotwJSXFactory('div', {className: "modal__container"}, [
                eotwJSXFactory('button', {className: "modal__close-btn js-close", title: "Close", 'aria-label': "Close Modal"}),
                eotwJSXFactory('div', {className: "modal__top"}, [
                    eotwJSXFactory('h2', {className: "heading heading--2"}, ["Europe’s best kept secret - No more!"]),
                    eotwJSXFactory('p', null, ["Large capacity ZAYER CNC bed, travelling-column and gantry-type milling machines: now available from Mills CNC."])
                ]),
                eotwJSXFactory('div', {className: "modal__image-middle"}, [
                    eotwJSXFactory('picture', null, [
                        eotwJSXFactory('source', {media: "(min-width: 1921px)", srcSet: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--vw.jpg 1x, /wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--vw--2x.jpg 2x"}),
                        eotwJSXFactory('source', {media: "(min-width: 760px)", srcSet: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg.jpg 1x, /wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--2x.jpg 2x"}),
                        eotwJSXFactory('source', {media: "(min-width: 600px)", srcSet: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--phablet.jpg 1x, /wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--phablet--2x.jpg 2x"}),
                        eotwJSXFactory('source', {media: "(min-width: 410px)", srcSet: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--mobile-large.jpg 1x, /wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--mobile-large--2x.jpg 2x"}),
                        eotwJSXFactory('img', {src: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--mobile.jpg", srcSet: "/wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--mobile.jpg 1x, /wp-content/themes/mills-cnc/images/jpg/zayer-modal-bg--mobile--2x.jpg 2x", alt: "Zayer range of machines"})
                    ])
                ]),
                eotwJSXFactory('div', {className: "modal__bottom"}, [
                    eotwJSXFactory('a', {href: "/zayer-cnc-machines/", className: "btn js-view-page"}, [
                        eotwJSXFactory('span', {className: "btn__text"}, ["Discover the Zayer Range"]),
                        eotwJSXFactory('span', {className: "btn__arrow", unsafeHtml: svg_include('btn-arrow')})
                    ])
                ])
            ])
        ]));
    }

    bindEvents() {
        super.bindEvents();

        this.$modal.on('click', '.js-close', () => {
            CookieHelper.set('zayer-modal-dismissed', true, 365);
            this.close();
        }).on('click', '.js-view-page', function () {
            let url = $(this).attr('href');
            CookieHelper.set('zayer-modal-dismissed', true, 365);
            window.location.href = url;
            return false;
        });
    }
}
